// extracted by mini-css-extract-plugin
module.exports = {"x-page-header":"style_x-page-header__1EwG1"};